import { Autocomplete, Box, Button, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent, styled, Switch, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CuentaBancaria, DatosEmpresa, PropsCuentasBancarias } from "../../shared/VinculacionesModels";
import DeleteIcon from '@mui/icons-material/Delete';
import { ListadoBancos } from '../../shared/dataLists';
import { NombreTipoDocumento } from '../../shared/dataLists';
import { LoadingButton } from "@mui/lab";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddIcon from '@mui/icons-material/Add';
import { Dispatch, SetStateAction, useEffect } from "react";
import { useTenant } from "../../shared/Context";
import React from "react";

const VisuallyHiddenInput = styled('input')({
	clip: 'rect(0 0 0 0)',
	clipPath: 'inset(50%)',
	height: 1,
	overflow: 'hidden',
	position: 'absolute',
	bottom: 0,
	left: 0,
	whiteSpace: 'nowrap',
	width: 1,
});

const CuentasBancariasForm: React.FC<PropsCuentasBancarias> = ({ cuentasBancarias, setCuentasBancarias, datosEmpresa, idVinculacion }) => {
	const handleAgregarCuenta = () => {
		const nuevaCuenta: CuentaBancaria = {
			cuentaTercero: false,
			razonSocial: '',
			tipoDocumento: 31,
			documento: NaN,
			dv: '',
			banco: 0,
			tipoCuenta: 2,
			cuenta: '',
			certificacionBancaria: ''
		};
		setCuentasBancarias((prevState) => [...prevState, nuevaCuenta]);
	};

	return (
		<>
			<Typography variant='h6' sx={{ textAlign: 'left', mb: 3, mt: 3, fontWeight: '500' }}>
				Datos Bancarios
			</Typography>
			{cuentasBancarias.map((cuenta, i) => (
				<ComponenteCuenta cuenta={cuenta} index={i} setCuentasBancarias={setCuentasBancarias} datosEmpresa={datosEmpresa} idVinculacion={idVinculacion} />
			))}
			<Box mt={3}>
				<Button
					variant="text"
					startIcon={<AddIcon />}
					onClick={handleAgregarCuenta}
				>
					Agregar cuenta
				</Button>
			</Box>
		</>
	)
}

const ComponenteCuenta: React.FC<{
	cuenta: CuentaBancaria;
	index: number;
	setCuentasBancarias: Dispatch<SetStateAction<CuentaBancaria[]>>;
	datosEmpresa: DatosEmpresa
	idVinculacion: string
}> = ({ cuenta, index, setCuentasBancarias, datosEmpresa, idVinculacion }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const { tenantId } = useTenant()
	const [loading, setLoading] = React.useState(false)

	const handleEliminarCuenta = () => {
		setCuentasBancarias((prevState) => {
			const newState = prevState.filter((_, i) => i !== index);
			return newState;
		});
	}

	const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const name = event.target.name
		const value = event.target.value

		setCuentasBancarias((prevState) => {
			var newState = [...prevState]
			newState[index] = { ...newState[index], [name]: name === "documento" ? parseInt(value) : value }
			return newState
		})
	}

	const handleSelectChange = (event: SelectChangeEvent<number>) => {
		setCuentasBancarias((prevState) => {
			var newState = [...prevState]
			newState[index] = { ...newState[index], [event.target.name]: event.target.value }
			return newState
		})
	}

	const handleAutocompleteChange = (value: number | undefined) => {
		if (value) {
			setCuentasBancarias((prevState) => {
				var newState = [...prevState]
				newState[index] = { ...newState[index], banco: value }
				return newState
			})
		}
	}

	const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCuentasBancarias((prevState) => {
			var newState = [...prevState]
			newState[index] = { ...newState[index], [event.target.name]: event.target.checked }
			return newState
		})
	}

	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files) {
			const file = event.target.files[0];
			setLoading(!loading);
			handleSubmitFile(file);
		}
	}

	const handleSubmitFile = (file: File) => {
		if (file) {
			const formData = new FormData();
			formData.append('TenantId', tenantId);
			formData.append('IdVinculacion', idVinculacion);
			formData.append('File', file);
			fetch(process.env.REACT_APP_CORE_LAMBDA_VINCULACIONES_URL + 'cargueDocumento', {
				method: 'POST',
				body: formData
			})
				.then(response => {
					if (!response.ok) {
						throw new Error('Error al guardar la información');
					}
					setLoading(false);
					return response.json();
				})
				.then(data => {
					if (data.url) {
						setCuentasBancarias((prev) => {
							let newCuentas = [...prev]
							newCuentas[index] = { ...newCuentas[index], certificacionBancaria: data.url }
							return newCuentas;
						})
					}
				})
		}
	};

	const handleViewDocument = (documentKey: string) => {
		fetch(process.env.REACT_APP_CORE_LAMBDA_VINCULACIONES_URL + 'obtengaDocumento', {
			method: 'POST',
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				tenantId: tenantId,
				documentKey: documentKey
			})
		}).then(async (res) => {
			if (!res.ok) {
				throw new Error('Error al guardar la información');
			}
			let response = await res.json()
			window.open(response.signedUrl, "_blank", "noreferrer")
		})
	}

	useEffect(() => {
		if (!cuenta.cuentaTercero) {
			setCuentasBancarias((prev) => {
				let newCuentas = [...prev]
				newCuentas[index] = {
					...newCuentas[index],
					razonSocial: datosEmpresa.razonSocial,
					tipoDocumento: parseInt(datosEmpresa.tipoIdentificacion),
					documento: parseInt(datosEmpresa.identificacion),
					dv: datosEmpresa.dv
				}
				return newCuentas;
			})
		}
		else if (cuenta.razonSocial == datosEmpresa.razonSocial && cuenta.documento == parseInt(datosEmpresa.identificacion)) {
			setCuentasBancarias((prev) => {
				let newCuentas = [...prev]
				newCuentas[index] = {
					...newCuentas[index],
					razonSocial: '',
					tipoDocumento: 31,
					documento: NaN,
					dv: ''
				}
				return newCuentas;
			})
		}
	}, [cuenta.cuentaTercero])

	return (
		<Box sx={{ boxShadow: 3, p: isMobile ? 2 : 2, mb: 3, mt: 3, borderRadius: 3 }}>
			<Grid container>
				<Grid item xs={10} sx={{ display: 'flex', alignItems: 'center' }}>
					<Box sx={{ display: 'flex', justifyContent: 'left', textAlign: 'left', alignItems: 'center' }}>
						<Typography>Cuenta {index + 1}: {cuenta.cuenta}</Typography>
					</Box>
				</Grid>
				<Grid item xs={2}>
					<Box sx={{ display: 'flex', justifyContent: 'right' }}>
						<IconButton size='small' aria-label="delete" sx={{ color: '#a90000' }}
							onClick={handleEliminarCuenta}>
							<DeleteIcon />
						</IconButton>
					</Box>
				</Grid>
				<Grid item xs={12} sx={{ display: 'flex', padding: "0 0 20px 5px" }}>
					<FormControlLabel
						control={
							<Switch
								size='small'
								checked={cuenta.cuentaTercero}
								onChange={handleCheckChange}
								name="cuentaTercero"
							/>
						}
						label="Inscribir cuenta bancaria de un tercero"
					/>
				</Grid>
			</Grid>
			<Grid container spacing={isMobile ? 1 : 2}>
				<Grid item xs={12} md={12} sx={{ mt: 1 }}>
					<TextField
						fullWidth
						label="Razón social"
						variant="outlined"
						value={cuenta.razonSocial}
						type='text'
						onChange={handleChange}
						name='razonSocial'
						disabled={!cuenta.cuentaTercero}
					/>
				</Grid>
				<Grid item xs={12} md={6} sx={{ p: !isMobile ? 1 : 0, mt: 1 }}>
					<FormControl fullWidth sx={{ textAlign: 'left' }}>
						<InputLabel id="identification-type-label">Tipo de identificación</InputLabel>
						<Select
							labelId="identification-type-label"
							id="identification-type"
							label="Tipo de Identificación"
							value={cuenta.tipoDocumento}
							onChange={handleSelectChange}
							name='tipoDocumento'
							disabled={!cuenta.cuentaTercero}
						>
							{Object.entries(NombreTipoDocumento).map(([key, value]) => (
								<MenuItem key={Number(key)} value={Number(key)}>{value}</MenuItem>
							))}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={cuenta.tipoDocumento == 31 ? 9 : 12} md={cuenta.tipoDocumento === 31 ? 4 : 6} sx={{ mt: 1 }}>
					<TextField
						fullWidth
						label="Número de identificación"
						variant="outlined"
						value={Number.isNaN(cuenta.documento) ? '' : cuenta.documento}
						type='text'
						onChange={handleChange}
						name='documento'
						disabled={!cuenta.cuentaTercero}
					/>
				</Grid>
				{cuenta.tipoDocumento === 31 &&
					<Grid item xs={3} md={2} sx={{ p: !isMobile ? 1 : 0, mt: 1 }}>
						<TextField
							fullWidth
							label="DV"
							value={cuenta.dv}
							onChange={handleChange}
							variant="outlined"
							name="dv"
							type='text'
							disabled={!cuenta.cuentaTercero}
						/>
					</Grid>
				}
				<Grid item xs={12} md={6} sx={{ mt: 1 }}>
					<FormControl fullWidth>
						<Autocomplete
							id="banco"
							options={ListadoBancos}
							getOptionLabel={(option) => option.label}
							value={ListadoBancos.find((option) => option.value === cuenta.banco) || null}
							renderInput={(params) => <TextField {...params} label="Banco" />}
							onChange={(_, value) => handleAutocompleteChange(value?.value)}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={12} md={6} sx={{ mt: 1 }}>
					<FormControl fullWidth sx={{ textAlign: 'left' }}>
						<InputLabel id="tipo-cuenta-label">Tipo de cuenta</InputLabel>
						<Select
							labelId="tipo-cuenta-label"
							id="tipo-cuenta"
							value={cuenta.tipoCuenta}
							name='tipoCuenta'
							onChange={handleSelectChange}
							label="Tipo de cuenta"
						>
							<MenuItem value={2}>Ahorros</MenuItem>
							<MenuItem value={1}>Corriente</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={12} md={6} sx={{ mt: 1 }}>
					<TextField
						fullWidth
						label="Número de cuenta"
						variant="outlined"
						value={cuenta.cuenta}
						name='cuenta'
						type='text'
						helperText="Sin guiones ni puntos"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} md={6} sx={{ mt: 1 }}>
					<LoadingButton
						component="label"
						variant="outlined"
						loading={loading}
						startIcon={<CloudUploadIcon />}
						size='small'
						sx={{ margin: '0 2px' }}
					>
						Certificación bancaria
						<VisuallyHiddenInput
							type="file"
							accept=".pdf"
							name="certificacionBancaria"
							onChange={handleFileChange}
						/>
					</LoadingButton>
					{
						cuenta.certificacionBancaria && (
							<LoadingButton
								component="a"
								onClick={() => handleViewDocument(cuenta.certificacionBancaria)}
								target="_blank"
								variant="outlined"
								endIcon={<RemoveRedEyeIcon />}
								size={'small'}
								sx={{ margin: '0 2px' }}
							>
								Ver
							</LoadingButton>
						)}
				</Grid>
			</Grid>
		</Box>
	)
}

export default CuentasBancariasForm;